import { createAxiosInstance } from '../axiosCore';
import useAuth from '../useAuth';

/**
 * Axios hook - for both authenticated and public endpoints
 * @param isAuthenticationDisabled - Set to true for public endpoints that don't require authentication
 */
export const useAxios = ({ isAuthenticationDisabled = false }: { isAuthenticationDisabled?: boolean } = {}) => {
  const auth = useAuth();

  return createAxiosInstance(
    async (): Promise<Record<string, string>> => {
      if (isAuthenticationDisabled) {
        return {}; // No authentication headers for public endpoints
      }

      const token = await auth.getTokenSilently();
      return {
        Authorization: `Bearer ${token}`,
      };
    },
    isAuthenticationDisabled ? 'public request' : 'request'
  );
};
